<script>
import axios from 'axios'
import { Userpilot } from 'userpilot'
import { mapGetters } from 'vuex'

import { SupplierRoutes } from '../api/supplierRoutes'

import AdminHeader from '../components/AdminHeader'
import ProvidesIsMobileMixin from '~/mixin/ProvidesIsMobileMixin.js'

export default {
  mixins: [ProvidesIsMobileMixin],
  data: () => ({
    logged_in_admin_id: '',
    isadminLoggedIn: false,
    loginAsSupportAgent: false,
  }),

  computed: mapGetters({
    user: 'auth/user',
  }),

  components: {
    AdminHeader,
  },

  created() {
    // check if user is logged in
    if (this.user) {
      Userpilot.identify(this.user.id, {
        name: this.user.name,
        email: this.user.email,
        created_at: this.user.created_at,
      })
    }
  },

  beforeMount() {
    // check if cookie set for admin login
    if (this.getCookie('isAdminLoginAsUser')) {
      // set admin logged in to true if admin/support logged in as supplier
      this.isadminLoggedIn = true
      this.logged_in_admin_id = this.getCookie('logged_in_admin_id')
      // check if support agent is logged in
      if (this.getCookie('logged_in_admin_id') == 6) {
        this.loginAsSupportAgent = true
      }
    }
  },

  methods: {
    getCookie: function (cname) {
      var name = cname + '='
      var decodedCookie = decodeURIComponent(document.cookie)
      var ca = decodedCookie.split(';')
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i]
        while (c.charAt(0) == ' ') {
          c = c.substring(1)
        }
        if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length)
        }
      }
      return ''
    },

    loginAsAdmin: function () {
      axios
        .post(SupplierRoutes.loginAsAdmin, {
          id: this.logged_in_admin_id,
        })
        .then((response) => {
          let result = response.data

          let self = this
          // message
          this.loginmessage = result.message
          /*check reponse status*/
          if (result.status == 'success') {
            // Remove admin cookie
            document.cookie = 'isAdminLoginAsUser=;expires=Thu, 01 Jan 1970 00:00:01 GMT;'
            document.cookie = 'logged_in_admin_id=;expires=Thu, 01 Jan 1970 00:00:01 GMT;'
            document.cookie = 'logged_in_admin_access_role_id=;expires=Thu, 01 Jan 1970 00:00:01 GMT;'

            this.loginclass = 'green'
            self.loginAsSupportAgent = false
            setTimeout(function () {
              window.location.href = config.adminurl + '/users'
            }, 1000)
          } else {
            this.loginclass = 'red'
          }
          setTimeout(function () {
            self.loginclass = ''
            self.loginmessage = ''
          }, 1000)
        })
        .catch((error) => {})
    },
  },
}
</script>

<template>
  <div class="home-width">
    <div
      v-if="isadminLoggedIn"
      class="row header-admin-user"
    >
      <div class="text-center">
        <span class="loginasspan">Logged in as</span>
        <span class="usernamespan">{{ user.supplier.name }}</span>
      </div>
      <div @click="loginAsAdmin">
        <span class="admin-logout-span">Logout</span>
      </div>
    </div>
    <admin-header />
    <child />
  </div>
</template>
